import { Link } from "react-router-dom";
import { Reveal, GoldLine } from "@/components/Reveal";

const Story = () => (
    <section className="relative py-24 sm:py-36 overflow-hidden" data-testid="brand-story">
        <div className="max-w-[1500px] mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
            <div className="lg:col-span-7 relative">
                <Reveal>
                    <div className="relative aspect-[4/3] lg:aspect-[16/11] overflow-hidden border border-gold/15 group">
                        <img
                            src="/images/gold-set.jpg"
                            alt="Curated gold jewellery collection at BSK Jewellers Amritsar"
                            loading="lazy"
                            className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
                        />
                        <div className="absolute inset-0 bg-obsidian/20" />
                    </div>
                </Reveal>
                <Reveal delay={0.25} className="absolute -bottom-10 -right-2 sm:right-[-2rem] w-40 sm:w-64 hidden sm:block">
                    <div className="aspect-square overflow-hidden border border-gold/30 shadow-2xl shadow-black/60">
                        <img
                            src="/images/goldsmith-1.jpg"
                            alt="Goldsmith hand-finishing a ring for BSK Jewellers"
                            loading="lazy"
                            className="w-full h-full object-cover"
                        />
                    </div>
                </Reveal>
                <span className="absolute -top-6 -left-2 font-serif italic text-[7rem] leading-none text-gold/10 select-none hidden lg:block" aria-hidden="true">01</span>
            </div>
            <div className="lg:col-span-5 lg:pl-8">
                <Reveal>
                    <span className="eyebrow" data-testid="story-eyebrow">Our Heritage</span>
                </Reveal>
                <Reveal delay={0.08}>
                    <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.12] mt-5">
                        Jewellery That Becomes <span className="italic gold-text">Part of Your Story</span>
                    </h2>
                </Reveal>
                <GoldLine delay={0.2} className="w-20 my-7" />
                <Reveal delay={0.25}>
                    <p className="text-sand text-sm sm:text-base leading-relaxed">
                        Jewellery is more than an ornament. It becomes part of the moments we remember, the
                        celebrations we share and the people we cherish.
                    </p>
                    <p className="text-sand text-sm sm:text-base leading-relaxed mt-4">
                        At BSK Jewellers — Bhimsen Khanna Chandiwale, Rani Ka Bagh, Amritsar — every piece is
                        selected and crafted with that belief in mind: jewellery made not just to be worn,
                        but to be kept.
                    </p>
                </Reveal>
                <Reveal delay={0.35}>
                    <Link
                        to="/about"
                        data-testid="story-discover-btn"
                        className="inline-block mt-8 text-[11px] tracking-[0.25em] uppercase text-gold border-b border-gold/50 pb-1 hover:border-gold hover:tracking-[0.3em] transition-all duration-300"
                    >
                        Discover Our Story →
                    </Link>
                </Reveal>
            </div>
        </div>
    </section>
);

export default Story;
